import { useTheme } from "next-themes";
import { Sun, Moon, Monitor, Palette } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ThemeSettings = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();

  const themes = [
    { value: "light", label: "Light", icon: Sun },
    { value: "dark", label: "Dark", icon: Moon },
    { value: "system", label: "System", icon: Monitor },
  ];

  const isActive = (value: string) => {
    if (value === 'system') return theme === 'system';
    return theme === value || (theme === 'system' && resolvedTheme === value);
  };

  return (
    <div className="app-tile p-6">
      <div className="flex items-center gap-3 mb-1">
        <div className="app-icon-box">
          <Palette className="h-5 w-5" />
        </div>
        <div>
          <h3 className="app-section-title text-lg">Appearance</h3>
          <p className="text-sm text-muted-foreground">
            Choose how Email2Contact looks. Sync with system or pick a theme.
          </p>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-3 gap-3">
        {themes.map(({ value, label, icon: Icon }) => (
          <Button
            key={value}
            variant={isActive(value) ? "default" : "outline"}
            onClick={() => setTheme(value)}
            className="flex flex-col items-center gap-2 h-auto py-4 transition-all"
          >
            <Icon className="w-5 h-5" />
            <span className="text-sm">{label}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};
